// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Drawer footer ─────────────────────────────────────────────────────── */

.j0zBpBILuS7EDINc5wIo {
    flex-shrink: 0;
    display: flex;
    gap: 12px;
    padding: 12px 16px;
    border-top: 1px solid var(--curio-border);
    background: var(--curio-card-bg);
    font-family: var(--curio-font-family);
}

.unOsohm213SERfvwwrzu {
    flex: 0 0 auto;
    height: var(--curio-input-height);
    padding: 0 16px;
    border: 1px solid var(--curio-border-strong);
    border-radius: var(--curio-radius-md);
    background: var(--curio-card-bg);
    color: var(--curio-text-primary);
    font: inherit;
    font-size: var(--curio-font-size-lg);
    font-weight: 500;
    cursor: pointer;
    white-space: nowrap;
}

.unOsohm213SERfvwwrzu:hover:not(:disabled) {
    background: #f7f7f9;
}

.unOsohm213SERfvwwrzu:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

.OwHnNan3oqsCIOCLry1v {
    flex: 1;
    height: var(--curio-input-height);
    padding: 0 20px;
    border: none;
    border-radius: var(--curio-radius-md);
    background: var(--curio-top-bar-bg);
    color: var(--curio-text-on-dark);
    font: inherit;
    font-size: var(--curio-font-size-lg);
    font-weight: 600;
    cursor: pointer;
}

.OwHnNan3oqsCIOCLry1v:hover:not(:disabled) {
    background: #2c2d32;
}

.OwHnNan3oqsCIOCLry1v:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}
`, "",{"version":3,"sources":["webpack://./src/components/packages/publishing/DrawerFooter.module.css"],"names":[],"mappings":"AAAA,6EAA6E;;AAE7E;IACI,cAAc;IACd,aAAa;IACb,SAAS;IACT,kBAAkB;IAClB,yCAAyC;IACzC,gCAAgC;IAChC,qCAAqC;AACzC;;AAEA;IACI,cAAc;IACd,iCAAiC;IACjC,eAAe;IACf,4CAA4C;IAC5C,qCAAqC;IACrC,gCAAgC;IAChC,gCAAgC;IAChC,aAAa;IACb,oCAAoC;IACpC,gBAAgB;IAChB,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,OAAO;IACP,iCAAiC;IACjC,eAAe;IACf,YAAY;IACZ,qCAAqC;IACrC,mCAAmC;IACnC,gCAAgC;IAChC,aAAa;IACb,oCAAoC;IACpC,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB","sourcesContent":["/* ── Drawer footer ─────────────────────────────────────────────────────── */\n\n.footer {\n    flex-shrink: 0;\n    display: flex;\n    gap: 12px;\n    padding: 12px 16px;\n    border-top: 1px solid var(--curio-border);\n    background: var(--curio-card-bg);\n    font-family: var(--curio-font-family);\n}\n\n.footerGhost {\n    flex: 0 0 auto;\n    height: var(--curio-input-height);\n    padding: 0 16px;\n    border: 1px solid var(--curio-border-strong);\n    border-radius: var(--curio-radius-md);\n    background: var(--curio-card-bg);\n    color: var(--curio-text-primary);\n    font: inherit;\n    font-size: var(--curio-font-size-lg);\n    font-weight: 500;\n    cursor: pointer;\n    white-space: nowrap;\n}\n\n.footerGhost:hover:not(:disabled) {\n    background: #f7f7f9;\n}\n\n.footerGhost:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n}\n\n.footerPrimary {\n    flex: 1;\n    height: var(--curio-input-height);\n    padding: 0 20px;\n    border: none;\n    border-radius: var(--curio-radius-md);\n    background: var(--curio-top-bar-bg);\n    color: var(--curio-text-on-dark);\n    font: inherit;\n    font-size: var(--curio-font-size-lg);\n    font-weight: 600;\n    cursor: pointer;\n}\n\n.footerPrimary:hover:not(:disabled) {\n    background: #2c2d32;\n}\n\n.footerPrimary:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"footer": `j0zBpBILuS7EDINc5wIo`,
	"footerGhost": `unOsohm213SERfvwwrzu`,
	"footerPrimary": `OwHnNan3oqsCIOCLry1v`
};
export default ___CSS_LOADER_EXPORT___;
